import { Component, Input, OnInit } from '@angular/core';
import { MinuteRequestResolutionDTO } from '../../minutes/interface/minute-detail';
import { faCircleXmark, faClock, IconDefinition, faCheckCircle, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-minute-resolution-item',
  templateUrl: './minute-resolution-item.component.html',
  styleUrls: ['./minute-resolution-item.component.scss']
})
export class MinuteResolutionItemComponent implements OnInit{
  @Input() minuteResolution: MinuteRequestResolutionDTO;
  public iconResolution: IconDefinition = faClock;
  public iconColor: string = 'fa-orange';

  constructor(){
  }

  ngOnInit(): void {    
    switch(this.minuteResolution.resolutionState) {
      case 0:
        this.iconResolution = faClock;
        this.iconColor = 'fa-orange';
        break;
      case 2:
      case 7:
        this.iconResolution = faCheckCircle;
        this.iconColor = 'fa-green';
        break;
      case 3:
        this.iconResolution = faCircleXmark;
        this.iconColor = 'fa-red';
        break;
    }
  }
}
